<template>
  <b-modal
    id="subcontractors-view-modal"
    size="lg"
    ref="subcontractors_view_modal"
    title="Podgląd podwykonawców na budowie"
    @hidden="onClose"
    @show="onShow"
  >
    <ol class="list-tablelike">
      <li v-for="item in selected" :key="item.id">
          <b>{{ changePositionName(positions.find(pos => pos.id === item.position_id).name) }}</b>
          <span class="badge badge-warning" v-if="item.user_id === null">Nie wybrano</span>
          <span v-else class="constructionsub">{{ item.firstname }} {{ item.lastname }}<strong v-if="item.phone"><br/>Tel: {{ item.phone }}</strong></span>
      </li>
    </ol>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="outline-danger" @click="cancel()">Zamknij</b-button>
    </template>
  </b-modal>
</template>


<script>
import { mapGetters } from "vuex";
import { changePositionName } from "@/utils/index";

export default {
  name: "ConstructionModalSubcontractorsView",
  props: {
    subcontractors: { type: Array }
  },
  data() {
    return {
      selected: [
        {
          position_id: 1,
          user_id: null,
        },
        {
          position_id: 2,
          user_id: null,
        },
        {
          position_id: 3,
          user_id: null,
        },
        {
          position_id: 4,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
      ],
    }
  },
  computed: {
    ...mapGetters("app", ["positions"]),
  },
  methods: {
    changePositionName:changePositionName,
    onShow() {
      if (this.subcontractors.length > 0) {
        this.$_.each(this.subcontractors, (item) => {
          let that = this.$_.find(this.selected, {
            position_id: item.position_id,
            user_id: null,
          });
          if (that) {
            that.user_id = item.user_id;
            that.firstname = item.firstname;
            that.lastname = item.lastname;
            that.phone = item.phone;
          }
        });
      }
    },
    onClose() {
      this.selected = [
        {
          position_id: 1,
          user_id: null,
        },
        {
          position_id: 2,
          user_id: null,
        },
        {
          position_id: 3,
          user_id: null,
        },
        {
          position_id: 4,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
      ];
    },
  }
};
</script>